import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FragmentNames, RawProfileLayoutAliases } from '../../codegen';
import BaseController from '../BaseController';
import { BrokerService } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import { BS_ALTERNATIVE_LOGIN_VISIBILITY } from '../../constants/application-constants';

@Controller({ component: RawProfileLayoutAliases.RAW_PROFILE_LAYOUT, fragment: FragmentNames.RAW_PROFILE_LAYOUT })
export default class RawProfileLayoutController extends BaseController {

  @Inject(RawProfileLayoutAliases.PANEL_CARD_ALTERNATIVE_LOGIN_CONTROL_VISIBILITY)
    alternativeLoginControlVisibilityPanelAPI!: PanelAPI;

  @OnMount(RawProfileLayoutAliases.PANEL_ALTERNATIVE_LOGIN)
  handleMountPanelAlternativeLogin(): void {
    BrokerService.subscribeToTopic(BS_ALTERNATIVE_LOGIN_VISIBILITY, (visibility: boolean) => {
      this.alternativeLoginControlVisibilityPanelAPI.setVisible(visibility)
      this.alternativeLoginControlVisibilityPanelAPI.persistState();
    });
  }
}
